const Quoc = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-base sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-4xl sm:text-6xl sm:pb-5 md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-9xl'>Quốc Ca Việt Nam</h1>
        <p className='text-slate-300 pt-5 leading-tight'>
          Này công dân ơi, đứng lên đáp lời sông núi.<br />
          Đồng lòng cùng đi hy sinh tiếc gì thân sống.
        </p>
        <p className='text-blue-300 pt-5 leading-tight'>
          Vì tương lai quốc dân, cùng xông pha khói tên,<br />
          Làm sao cho núi sông từ nay luôn vững bền.
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Dù cho thây phơi trên gươm giáo.<br />
          Thù nước lấy máu đào đem báo.
        </p>
        <p className='text-violet-300 pt-5 leading-tight'>
          Nòi giống lúc biến phải cần giải nguy,<br />
          Người công dân luôn vững bền tâm trí,
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Hùng tráng quyết chiến đấu làm cho khắp nơi,<br />
          Vang tiếng người nước Nam cho đến muôn đời.
        </p>
        <p className='text-fuchsia-300 pt-5 leading-tight'>
          Công dân ơi! Mau hiến thân dưới cờ,<br />
          Công dân ơi! Mau làm cho cõi bờ,
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Thoát cơn tàn phá vẻ vang nòi giống,<br />
          Xứng danh nghìn năm giống Lạc Hồng!
        </p>
      </div>
    </div>
  )
}

export default Quoc
